module.exports = require("wrong-module");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-module1/index.js
 ** module id = 1
 ** module chunks = 0
 **/